/* eslint-disable no-nested-ternary */
import React from 'react';
import { TOPIC_CARD_TYPE, TOI_LIVE_DOMAIN, VIEW_ALL } from 'constants/index';
import VsCard from '../../../../../components_v2/common/VsCard';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import s from './TopicCard.scss';

const TopicCard = props => {
  const {
    cards,
    headline,
    cardType,
    loadMoreTabData,
    classname,
    isWapView,
    hideMoreBooks,
    imageWrapClassName,
  } = props;

  if (!cards || !cards.length) {
    return null;
  }

  const getCelebsLink = card => {
    if (cardType === TOPIC_CARD_TYPE.CELEBSCARDS) {
      return `${TOI_LIVE_DOMAIN}/topic${card.linkUrl}`;
    }
    return card.url || card.linkUrl;
  };

  const getComponent = (card, idx) => (
    <div className={`${s.card}`} key={idx}>
      <VsCard
        title={card.name || card.title}
        msid={card.imageId || card.id}
        src={card.imageUrl}
        width={168}
        wu={getCelebsLink(card)}
        isLarge={false}
        sectionName={
          cardType === TOPIC_CARD_TYPE.CELEBSCARDS ? card.celebType : ''
        }
        index={0}
        lazyloadImg
        imageWrapClassName={imageWrapClassName}
      />
      {cardType === TOPIC_CARD_TYPE.BOOKS && (
        <div className={s.buynow}>
          <button type="button" onClick={() => window.open(card.linkUrl)}>
            Buy Now
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div className={`${s.trending_box} ${classname} common_story_card`}>
      {headline && (
        <Listingheader headingname={headline} overrideClass={s.topicheading} />
      )}
      <div className={s.card_show}>
        {Array.isArray(cards) && cards.length > 0
          ? cards.map((el, idx) => getComponent(el, idx))
          : null}
      </div>
      {(cardType === TOPIC_CARD_TYPE.BOOKS ||
        cardType === TOPIC_CARD_TYPE.FILMOGRAPHY) &&
        !isWapView && (
          <div className={s.loadMore}>
            <button type="button" onClick={() => loadMoreTabData(cardType)}>
              {VIEW_ALL}
            </button>
          </div>
        )}
      {cardType === TOPIC_CARD_TYPE.BOOKS &&
        isWapView &&
        !hideMoreBooks && (
          <button
            className={s.moreBtn}
            onClick={() => loadMoreTabData(cardType)}
          >
            More Books
          </button>
        )}
    </div>
  );
};

export default TopicCard;
